// extracted by mini-css-extract-plugin
export default {"cards":"WordCards_cards__xAQ8o","empty":"WordCards_empty__xbh7H"};